import FetchManagementTeam from 'utils/fetch/management/FetchManagementTeam'
import { constantsGraphql } from 'utils/constants/constants'

export const fetchManagementTeams = ({ callbackStart, callbackError, callbackSuccess}) => {
	FetchManagementTeam.fetchAll({
		variables: {
			visible_for_employees: constantsGraphql.YES_NO,
			verified: constantsGraphql.YES_NO,
			active: constantsGraphql.YES_NO,
		},
		callbackStart,
		callbackError,
		callbackSuccess,
	});
}
